import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})

export class DeveloperService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //Get OnHold Transaction Report List with Pagination
    getDeveloperReport(pageNumber:any,pageRecords:number,dateFrom:String,dateTo:String,customerId:string,transactionId:string) {
    var url = "";
    var filter = "";
    if(dateFrom != "" && dateTo!=""){
        filter = filter+`&createDate=gte%3D${dateFrom} 00:00:00%24lte%3D${dateTo} 23:59:59`
    }
    if(customerId != "" && customerId != null){
        filter = filter+`&userId=${customerId}`
    }
    if(transactionId != "" && transactionId != null){
        filter = filter+`&txnId=${transactionId}`
    }
    //  url = `${API_URLBLAZE}/user/developer-portal/getDeveloperList??page_size=${pageRecords}&page_no=${pageNumber}&sort_dir=DESC&sort_column=createDate`+filter;
        url = `http://localhost:8082/user/developer-portal/getDeveloperList?page_size=${pageRecords}&page_no=${pageNumber}&sort_dir=DESC&sort_column=createDate`+filter;

    return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //save Activity TImeline
    updateDeveloper(emailId: any,status:any) {
        // const url = `${API_URLBLAZE}/user/developer-portal/update/${emailId}/${status}`;
        const url = `http://localhost:8082/user/developer-portal/update/${emailId}/${status}`;
        return this.http.put(url,null).pipe(catchError(this.handleError()));
    }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}